export default __webpack_public_path__ + "static/media/cgb_intro.9405e00c.png";